var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleKMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 57,
    viewBox: "0 0 46 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8009 0C10.2114 0 0 10.2068 0 22.8009C0 35.395 21.6018 57 22.8009 57C24 57 45.6018 35.3996 45.6018 22.8032C45.6018 10.2068 35.3904 0 22.8009 0ZM22.8009 31.9213C17.7642 31.9213 13.6805 27.8376 13.6805 22.8009C13.6805 17.7642 17.7642 13.6805 22.8009 13.6805C27.8376 13.6805 31.9213 17.7642 31.9213 22.8009C31.9213 27.8376 27.8376 31.9213 22.8009 31.9213Z",
    fill: "url(#paint0_linear_2111_103491)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2111_103491",
    x1: 22.8009,
    y1: 0,
    x2: 22.8009,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF352A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF972A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleKMarker);
export default __webpack_public_path__ + "static/media/circle-k-marker.86dec5bd93235fb39edd4cbc491e4554.svg";
export { ForwardRef as ReactComponent };